// extracted by mini-css-extract-plugin
export default {"img":"MainPage_img__vcCBI","result":"MainPage_result__xoGZu","resultInner":"MainPage_resultInner__vJQ8Y"};